import { render, staticRenderFns } from "./PrivatePayments.vue?vue&type=template&id=99d352f4&scoped=true&"
import script from "./PrivatePayments.vue?vue&type=script&lang=js&"
export * from "./PrivatePayments.vue?vue&type=script&lang=js&"
import style0 from "./PrivatePayments.vue?vue&type=style&index=0&id=99d352f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d352f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-web/node_modules/@vue/cli-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99d352f4')) {
      api.createRecord('99d352f4', component.options)
    } else {
      api.reload('99d352f4', component.options)
    }
    module.hot.accept("./PrivatePayments.vue?vue&type=template&id=99d352f4&scoped=true&", function () {
      api.rerender('99d352f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PrivatePayments.vue"
export default component.exports